'use strict';
(function($){
    /*
     * Vetology.FormatNumberPhone widget
     *
     * @description This widget is responsible for validating phone numbers depending on the number of digits in each country.
     *
     * @options					See description for each option
     *
     * @method	See description above each method
     */
    $.widget(
        'Vetology.FormatNumberPhone',
        {
            "options": {
            },
            /*
             * Vetology.Vetology._init
             *
             * @description	Initialize the initial events
             *
             * @return NULL
             *
             */
            "_init": function(){

                var o = this;
                o._loadEvents();
            },
            /*
             * Vetology.Vetology._doSomething
             *
             * @description	Placeholder for a method
             *
             * @return NULL
             *
             */
            "_doSomething": function(){

            },
            /*
             * Vetology.Vetology._loadEvents
             *
             * @description	The event is loaded by changing the country code of the telephone number

             *
             * @return NULL
             *
             */
            "_loadEvents": function(){
                var o = this;

                $("body").on("change", ".CountryCode", function(e){

                    var inputPhoneName = $(this).siblings().attr("name");
                    o._formatNumberPhoneCountry(this, inputPhoneName);
                });

                $("body").on("keydown", ".phoneNumber", function(e){

                    var inputPhoneName = $(this).attr("name");
                    var writingEvent = 'writing-event-'+inputPhoneName;
                    o._saveTempNumberPhone(inputPhoneName);

                    if(typeof(o.options[writingEvent]) == 'undefined'){
                        o.options[writingEvent] = true;
                    }

                    if(o.options[writingEvent]){
                        o._insertNumberFormatWhenWriting(inputPhoneName);
                        o._showPreviousNumberButton(inputPhoneName);
                        o.options[writingEvent] = false;
                    }
                });

                $("body").on("click", ".previousNumberButton", function(e){
                    var previousNumberButtonName  = $(this).attr("name");
                    var maskName = '.mask_'+previousNumberButtonName;
                    var nsnTempPhoneNumber = o.options[previousNumberButtonName].length;
                    var writingEvent = 'writing-event-'+previousNumberButtonName;

                    o._calculatePhoneMask(nsnTempPhoneNumber,maskName);
                    $(maskName).val(o.options[previousNumberButtonName]);

                    o._hiddenPreviousNumberButton(previousNumberButtonName);
                    o.options[writingEvent] = true;
                    delete o.options[previousNumberButtonName];
                });

                $("body").on("click", ".closeLevel", function(e){
                    o.options = {};
                });

            },

            /*
             * Vetology.Vetology._getTerritoryLabelsForCountry
             *
             * @description Build the number format depending on the number of digits it occupies according to the country.
             *
             */
            "_formatNumberPhoneCountry": function(el,inputPhoneName){
                var o = this;
                var sizeNsnCountry = 0;
                var maskName = '.mask_' + inputPhoneName;

                if(inputPhoneName == 'RespPersonCell' || inputPhoneName =='CelPhone' ){
                    sizeNsnCountry = $(el).find('option:selected').attr("size_nsn_mobile");
                }else{
                    sizeNsnCountry = $(el).find('option:selected').attr("size_nsn");
                }

                o._calculatePhoneMask(sizeNsnCountry,maskName);
            },

            "_insertNumberFormatWhenWriting": function (inputPhoneName) {
                var o = this;
                var sizeNsnCountry = 0;
                var maskName = '.mask_' + inputPhoneName;

                if(inputPhoneName == 'RespPersonCell' || inputPhoneName =='CelPhone' ){
                    sizeNsnCountry = $('.CountryCode').find('option:selected').attr("size_nsn_mobile");
                }else{
                    sizeNsnCountry = $('.CountryCode').find('option:selected').attr("size_nsn");
                }

                if (typeof sizeNsnCountry === "undefined" || sizeNsnCountry <= 0) {
                    // not all phone # fields follow the same conventions of storing the number as a simple string of digits
                    return;
                }

                o._calculatePhoneMask(sizeNsnCountry,maskName);
            },

            "_calculatePhoneMask": function (sizeNsnCountry, maskName) {
                var phoneMask = '';

                for(var i = 1; i <= parseInt(sizeNsnCountry); i++){
                    phoneMask += '9';
                }
                phoneMask = "'mask': '" + phoneMask +"'";

                $(maskName).attr("data-inputmask", phoneMask);
                $(maskName).inputmask();
                $(maskName).val('');
            },

            "_hiddenPreviousNumberButton": function (previousNumberButtonName) {
                var buttonName = '#button_'+ previousNumberButtonName;
                $(buttonName).addClass('hidden');
            },
            
            "_showPreviousNumberButton": function (previousNumberButtonName) {
                var buttonName = '#button_'+ previousNumberButtonName;
                $(buttonName).removeClass('hidden');
            },

            "_saveTempNumberPhone": function (inputPhoneName) {
                var o = this;
                var elementPhoneName = '.mask_' + inputPhoneName;
                var tempPhoneNumber = $(elementPhoneName).val();

                if(typeof(o.options[inputPhoneName]) == 'undefined'){
                    o.options[inputPhoneName] = tempPhoneNumber;
                }
            }

        }
    );
})(jQuery);
